<template>
  <dialog data-ts="Modal" id="helpButtonModal">
    <div data-ts="Panel">
      <main data-ts="Main" style="left: 0; max-width: 1280px" class="container">
        <div
          class="list-group"
          v-for="helpInfo in helpArray"
          :key="helpInfo.feature_id"
        >
          <div>
            <h2>{{ helpInfo.title }}</h2>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="helpInfo.content"></div>
          </div>
        </div>
      </main>
    </div>
  </dialog>
</template>
<script>
import axios from 'axios';
import { notify } from '../../../utils';

export default {
  data() {
    return {
      helpArray: [],
    };
  },
  mounted() {
    const _this = this;
    ts.ui.get('#helpButtonModal', (modal) => {
      Object.assign(modal, {
        onopen: () => {
          modal.title('Juvo Documentation');
          modal
            .buttons([
              {
                label: 'Close',
                type: 'ts-secondary',
                onclick() {
                  modal.close();
                },
              },
            ])
            .open();
          _this.getHelp();
        },
      });
    });
  },

  methods: {
    getHelp() {
      const _this = this;
      return axios.get('/help', {}).then(
        (resp) => {
          _this.helpArray = resp.data;
        },
        (error) => {
          notify.failed(error, 'Could not retrieve the help');
        }
      );
    },
  },
};
</script>
